import React from 'react';
import { makeStyles } from 'tss-react/mui';
import groupBy from 'lodash-es/groupBy';

import { Container, Grid, Typography, Link } from '@ha/dsl';

import { useIntl } from 'ha/i18n';
import { TopicCluster } from 'ha/modules/Hermes/types';

const useStyles = makeStyles()(theme => ({
  wrapper: {
    marginBottom: theme.spacing(5),
  },
  topicClusters: {
    marginBottom: theme.spacing(3),
  },
}));

interface Props {
  articles: Array<{
    description: string;
    headerImage: string;
    pathname: string;
    title: string;
    topicCluster: TopicCluster;
  }>;
  clusters: {
    title?: string;
    description?: string;
  };
}

export const CountryCityBlogList: React.FC<Props> = ({
  articles,
  clusters,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const categories = React.useMemo(
    () => groupBy(articles, 'topicCluster'),
    [articles],
  );

  const categoryList = React.useMemo(
    () => [
      {
        title: T('countryCity.category.rentingAbroad'),
        collection: categories.rentingAbroad,
      },
      {
        title: T('countryCity.category.movingAbroad'),
        collection: categories.movingAbroad,
      },
      {
        title: T('countryCity.category.livingIn'),
        collection: categories.livingIn,
      },
      {
        title: T('countryCity.category.studying'),
        collection: categories.studying,
      },
      {
        title: T('countryCity.category.working'),
        collection: categories.working,
      },
    ],
    [categories, T],
  );

  return (
    <Container
      maxWidth="lg"
      className={classes.wrapper}
      data-test-locator="Categorized blog links"
    >
      {clusters?.title && (
        <section className={classes.topicClusters} id="topicClusters">
          <Typography.H2>{clusters.title}</Typography.H2>
          <Typography.Paragraph>{clusters.description}</Typography.Paragraph>
        </section>
      )}

      <Grid item container xs={12} md={7} spacing={4} direction="column">
        {categoryList
          .filter(({ collection }) => Boolean(collection?.length))
          .map(({ title, collection }) => (
            <Grid item key={title} id={collection[0].topicCluster}>
              <Typography.H2>{title}</Typography.H2>
              {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
              {collection!.map(link => (
                <Typography.Paragraph key={link.pathname}>
                  <Link kind="hover-underline" to={link.pathname}>
                    {link.title}
                  </Link>
                </Typography.Paragraph>
              ))}
            </Grid>
          ))}
      </Grid>
    </Container>
  );
};
